import { useCallback } from 'react';
import { useEvent, openPromotionalWebsiteInNewTab } from '@bizzabo/entities';
import { sendCustomClick } from '@bizzabo/widget-analytics';
import useEventUniqueName from './useEventUniqueName';
import useIsEventExperienceSummitEvent from './useIsEventExperienceSummitEvent';

const useGoToHomePage = () => {
    const isEventExperienceSummitEvent = useIsEventExperienceSummitEvent();
    const eventUniqueName = useEventUniqueName();
    const { data: event } = useEvent(eventUniqueName);

    const goToHomePage = () => {
        sendCustomClick(
            {
                buttonType: 'GO_TO_VIA_VISIT_EVENT_WEBSITE',
                subCategory: '',
            },
            true
        );
        openPromotionalWebsiteInNewTab(event, isEventExperienceSummitEvent);
    };

    return useCallback(goToHomePage, [event]);
};

export default useGoToHomePage;
